import React from 'react';
import { Alert, Box, Card, CardContent, Typography } from '@mui/material';

const InsightsPanel = ({ insightsData = {} }) => {
  const weakArea = insightsData?.weakArea || insightsData?.weakAreas?.[0] || null;
  const trend = insightsData?.trend || null;
  const streak = insightsData?.streak || null;
  const suggestion =
    insightsData?.suggestion ||
    (weakArea ? `Practice more ${weakArea.label || 'targeted'} problems` : 'Keep consistency this week');

  const trendLabel =
    trend?.trend === 'up'
      ? 'Trend improving'
      : trend?.trend === 'down'
        ? 'Trend declining'
        : 'Trend stable';

  const streakLabel = streak
    ? streak.isActive
      ? `Active streak: ${streak.currentStreak || 0}d`
      : streak.message || 'Streak inactive'
    : 'Streak data unavailable';

  const items = [
    {
      title: 'Weak Area',
      severity: weakArea ? 'error' : 'success',
      text: weakArea?.message || 'No major weak area detected',
    },
    {
      title: 'Trend',
      severity: trend?.trend === 'up' ? 'success' : trend?.trend === 'down' ? 'error' : 'warning',
      text: trend ? `${trendLabel} (${Math.abs(trend.changePct || 0)}%)` : 'Trend data unavailable',
    },
    {
      title: 'Streak',
      severity: streak?.isActive ? 'success' : 'warning',
      text: streakLabel,
    },
    {
      title: 'Suggestion',
      severity: 'warning',
      text: suggestion,
    },
  ];

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ py: 1.25 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: 1,
          }}
        >
          {items.map((item) => (
            <Alert key={item.title} severity={item.severity} sx={{ py: 0.25 }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.1 }}>
                {item.title}
              </Typography>
              <Typography variant="body2" noWrap>
                {item.text}
              </Typography>
            </Alert>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default InsightsPanel;
